// extracted by mini-css-extract-plugin
module.exports = {"autoplayer":"autoplayer___3Sqlz","clickDisable":"clickDisable___244As"};